/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusSquareIcon64Regular = forwardRef('MinusSquareIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M19 30.5a1.5 1.5 0 0 0 0 3h26a1.5 1.5 0 0 0 0-3H19Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5 7C11.701 7 7 11.701 7 17.5v29C7 52.299 11.701 57 17.5 57h29C52.299 57 57 52.299 57 46.5v-29C57 11.701 52.299 7 46.5 7h-29ZM10 17.5a7.5 7.5 0 0 1 7.5-7.5h29a7.5 7.5 0 0 1 7.5 7.5v29a7.5 7.5 0 0 1-7.5 7.5h-29a7.5 7.5 0 0 1-7.5-7.5v-29Z" })));
});
